import React from 'react';
import { Chip, Stack } from '@mui/material';
import {
    EditNote as EditNoteIcon,
    PercentTwoTone as PercentIcon,
    PersonOutline as PersonIcon,
    TwoWheeler as TwoWheelerIcon
} from '@mui/icons-material';
import { CartSummary } from '@api/ShoppingCart/ShoppingCart';

// Acciones DEL PEDIDO, juntas y siempre visibles (PLAN-REDISENO-PANEL-POS-Y-RECIBO,
// D3 — validado por Irving: "reagrupar los 4").
//
// Antes estaban repartidas en tres lugares y dos de ellas se PERDÍAN: el envío y
// la promoción vivían DENTRO de la lista que scrollea, y el cliente y la nota en
// `OrderCustomerForm`, que solo se renderiza si el pedido ya tiene cliente.
//
// ⚠️ REGLA (ajuste de Irving, 2026-08-27): **el chip es SOLO un indicador de que
// eso ya se agregó** — encendido = puesto, apagado = toca para ponerlo. El VALOR
// (nombre, texto de la nota, código, importe) y el bote de basura viven ABAJO, en
// el resumen y en la fila del cliente. Poner el valor también aquí duplicaba
// todo en pantalla, que es justo lo que se estaba tratando de despejar.
interface OrderActionsBarProps {
    shoppingCart?: CartSummary;
    onToggleGetCustomer: () => void;
    onToggleAddNote: () => void;
    onTogglePromo: () => void;
    onAddShipping: () => void;
}

// El walk-in por default se llama '0000': para el cajero eso NO es un cliente
const hasRealCustomer = (shoppingCart?: CartSummary): boolean => {
    const name = shoppingCart?.customer?.profile?.name;
    return !!name && name !== '0000';
};

const CHIP_SX = { height: 40, borderRadius: 2, flex: 1, '& .MuiChip-label': { px: 1 } };

export const OrderActionsBar: React.FC<OrderActionsBarProps> = ({
    shoppingCart,
    onToggleGetCustomer,
    onToggleAddNote,
    onTogglePromo,
    onAddShipping
}) => {
    const actions = [
        {
            key: 'customer',
            label: 'Cliente',
            icon: <PersonIcon />,
            applied: hasRealCustomer(shoppingCart),
            onClick: onToggleGetCustomer
        },
        {
            key: 'note',
            label: 'Nota',
            icon: <EditNoteIcon />,
            applied: !!shoppingCart?.note,
            onClick: onToggleAddNote
        },
        {
            key: 'promo',
            label: 'Promoción',
            icon: <PercentIcon />,
            applied: !!shoppingCart?.promotionalCode,
            onClick: onTogglePromo
        },
        {
            key: 'shipping',
            label: 'Envío',
            icon: <TwoWheelerIcon />,
            applied: (shoppingCart?.shippingCost || 0) > 0,
            onClick: onAddShipping
        }
    ];

    return (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {actions.map((action) => (
                <Chip
                    key={action.key}
                    icon={action.icon}
                    label={action.label}
                    onClick={action.onClick}
                    color={action.applied ? 'primary' : 'default'}
                    variant={action.applied ? 'filled' : 'outlined'}
                    sx={CHIP_SX}
                />
            ))}
        </Stack>
    );
};
